import { Info, List } from "template/ListTemplate.style";
import { ModalContainer, ModalWrapper } from "./style";
import { Search, Wrapper } from "template/SearchTemplate.style";
import { useState } from "react";
import { PLACEHOLDER } from "constants/baseStyle";
import {
  HTTP_METHOD,
  POST_FIND_USER_WALLET_MOVE,
} from "constants/pathConstant";
import { useMutationCustom } from "hooks/useMutationCustom";

const SearchUserModal = ({ setIsOpen, setUserData }) => {
  const [acctUserNm, setAcctUserNm] = useState("");

  const [userList, setUserList] = useState([]);

  const { mutate } = useMutationCustom(
    POST_FIND_USER_WALLET_MOVE,
    HTTP_METHOD.POST
  );

  const handleSearch = () => {
    if (!acctUserNm) return;

    mutate(
      { acctUserNm },
      {
        onSuccess: (data) => {
          setUserList(data);
        },
      }
    );
  };

  const selectUser = (v) => {
    setUserData({ ...v, useTypeList: userList.useTypeList });
    setIsOpen(false);
  };

  const handleEnter = (key) => {
    if (key === "Enter") handleSearch();
  };

  return (
    <>
      <ModalWrapper
        onClick={() => {
          setIsOpen((prev) => !prev);
        }}
      />
      <ModalContainer>
        {/* 조회 */}
        <Wrapper style={{ width: "100%" }}>
          <List.Text>회원 조회</List.Text>
          <Search.Container>
            <Search.Content>
              <Search.InputWrapper>
                <div>회원명</div>
                <Search.Input
                  placeholder={PLACEHOLDER.ALL}
                  onChange={(e) => setAcctUserNm(e.target.value)}
                  onKeyUp={(e) => handleEnter(e.key)}
                />
              </Search.InputWrapper>
            </Search.Content>
            <Search.Btn onClick={() => handleSearch()}>조회</Search.Btn>
          </Search.Container>
        </Wrapper>

        {/* 리스트 */}
        <List.ModalScrollContainer>
          <List.Content>
            {/* 번호 */}
            <List.Row>번호</List.Row>
            {/* 회원명 */}
            <List.Row>회원명</List.Row>
            {/* 회원코드 */}
            <List.Row>회원코드</List.Row>
            {/* 생년월일 */}
            <List.Row>생년월일</List.Row>
            {/* 이메일 */}
            <List.Row $ratio={1.8}>이메일</List.Row>
            {/* 전화번호 */}
            <List.Row $ratio={1.5}>전화번호</List.Row>
          </List.Content>

          {/* 리스트 상세 */}
          <Info.Wrapper>
            {userList?.map((v) => (
              <Info.Content
                key={v.id}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  selectUser(v);
                }}
              >
                {/* 번호 */}
                <List.Row>{v.id}</List.Row>
                {/* 회원명 */}
                <List.Row>
                  {v.acctUserNm}
                  {v.state === "탈퇴" && `(탈퇴)`}
                </List.Row>
                {/* 회원코드 */}
                <List.Row>{v.acctCd}</List.Row>
                {/* 생년월일 */}
                <List.Row>{v.bornedDay}</List.Row>
                {/* 이메일 */}
                <List.Row $ratio={1.8}>{v.email}</List.Row>
                {/* 휴대전화번호 */}
                <List.Row $ratio={1.5}>{v.cellNumber}</List.Row>
              </Info.Content>
            ))}
          </Info.Wrapper>
        </List.ModalScrollContainer>
      </ModalContainer>
    </>
  );
};

export default SearchUserModal;
